import React, { useEffect } from "react";
import {
  Table,
  Select,
  Input,
  Button,
  message,
  Modal,
  Form,
  DatePicker,
  Upload,
  Space,
  TimePicker,
  Col,
  Row,
  Spin,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Trash } from "../../assets/trash.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useState } from "react";
import { ReactComponent as Tick } from "../../assets/tick.svg";
import { CALL_API } from "common/API";
import { ReactComponent as UploadIcon } from "../../assets/uploadicon.svg";
import {
  getClientid,
  getUserInfo,
  getUserList,
  getMenuList,
  getUserRoleId,
} from "redux/selectors";
import { STATUS_CODE } from "common/Constants";
import { connect } from "react-redux";
import moment from "moment";
import { object } from "prop-types";
import { find, get } from "lodash";
import ReportIncident from "./ReportIncident";
import { useTranslation } from "react-i18next";

const CustomStyle = styled.div`
  .ant-modal-content {
    box-shadow: none !important;
    background-color: white !important;
    border-radius: 10px;
  }
  .ant-modal {
    box-shadow: none !important;
  }
  .ant-table {
    border: 1px solid #e2e2e8;
    border-radius: 8px;
  }
  .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: 500;
    color: #1f243b;
  }
  .ant-table-tbody > tr > td {
    font-size: 15.2px;
    font-weight: 400;
    color: #636980;
  }
  .total {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .in {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  .inci {
    font-weight: 400 !important;
    font-size: 14px !important;
  }
  .action-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
    margin-left: 0px;
  }
  .search {
    width: 200px;
    height: 34px;
    border-radius: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
    margin-left: 2px;
  }
  .dropdown-container a:hover {
    color: #1890ff;
  }
  .dropdown-container a .anticon {
    margin-left: 5px;
    font-size: 9px;
  }
  .datepicker-style {
    width: 180px;
    height: 34px;
    border-radius: 24px;
  }
  .date-range-container {
    display: flex;
  }
  .action-icons {
    display: none;
    gap: 16px;
  }
  .ant-table-tbody > tr:hover .action-icons {
    display: flex;
  }
  .custom-row td {
    height: 70px;
    vertical-align: middle;
  }
  .suspend-text {
    color: #f28916;
  }
  .res-text {
    color: #08c108;
  }
  .dis-text {
    color: #ee2738;
  }
  .ant-modal {
    z-index: 9999 !important;
  }
  .ant-modal-body {
    overflow-y: auto;
  }
  .adjust-margin {
    margin-top: 10px;
    margin-left: 3px;
  }
  @media (max-width: 768px) {
    .total {
      display: block !important;
    }
    .search {
      margin-bottom: 10px !important;
      margin-left: 0 !important;
    }
    .action-dropdown {
      margin-bottom: 10px !important;
      margin-left: -12px !important;
    }
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal {
    background: rgba(0, 0, 0, 0.04) !important;
  }
  .ant-modal-title {
    font-size: 18px;
    font-weight: 500;
  }
  .custom-cancel-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
  }
  .custom-ok-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    background-color: #2d53da;
    color: #ffffff;
  }
  .form-split {
    display: flex;
    gap: 32px;
  }
  .input-width {
    width: 50%;
  }
  .form-datepicker {
    width: 100%;
  }
  .upload-style {
    width: 190px;
    height: 37px;
    border-radius: 5px;
    background-color: #e3e8fc;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
  }
  .upload-icon {
    margin-bottom: 3px;
  }
  .button-style {
    gap: 20px;
  }
  .success-modal {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .sent-successfully {
    font-size: 16px;
    font-weight: 400;
  }
  .suspension-from {
    display: flex;
    gap: 150px;
  }
  .suspension-to {
    display: flex;
    gap: 167px;
  }
  .payment-type {
    display: flex;
    gap: 170px;
  }
  .suspension-title {
    font-weight: 500;
    font-size: 14px;
    color: #636980;
  }
  .suspension-data {
    font-weight: 400;
    font-size: 16px;
  }
  .close-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    color: #2d53da;
  }
  .no-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    color: #2d53da;
  }
  .yes-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #2d53da;
    color: #ffffff;
  }
  .delete-modal-text {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .yes-no-button {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
`;

const props = {
  name: "file",
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  headers: {
    authorization: "authorization-text",
  },
  onChange(info) {
    if (info.file.status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};

const MyIncident = ({ userInfo, ClientId, userList, menuList, userRoleId }) => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const history = useHistory();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [showDateRange, setShowDateRange] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const [selectedRecord, setSelectedRecord] = useState({});

  const handleEditDisciplinary = (record) => {
    setSelectedIncidentId(record.incidentId);
    setSelectedRecord(record);
    setIsModalOpen(true);
  };

  useEffect(() => {}, [selectedRecord]);

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDeletedModalOpen, setIsDeletedModalOpen] = useState(false);
  const [isSavedModalOpen, setIsSavedModalOpen] = useState(false);

  const handleDeleteClick = (id) => {
    setIncidentToDelete(id);
    setIsDeleteOpen(true);
  };

  const handleCancel = () => setIsModalOpen(false);
  const handleDeleteCancel = () => setIsDeleteOpen(false);

  const [form] = Form.useForm();
  const [showLoader, toggleLoader] = useState(false);
  const [assetsData, setDisData] = useState([]);
  const [selectedIncidentId, setSelectedIncidentId] = useState(null);
  const [incidentToDelete, setIncidentToDelete] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const getDisData = async () => {
    try {
      setLoading(true);
      const { data, code } = await CALL_API(
        `incident/${userInfo?.userid}`,
        "get",
        {}
      );
      if (code === "SUCCESS" && Array.isArray(data)) {
        setDisData([...data]?.reverse());
        setFilteredData(data);
      } else {
        console.error("Invalid API Response:", data);
        message.error(t("Failed to fetch data. Please try again."));
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error(t("Something went wrong while fetching data."));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDisData();
  }, []);

  const columns = [
    {
      title: t("Incident ID"),
      dataIndex: "incidentId",
      key: "incidentId",
    },
    {
      title: t("Name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("Employee ID"),
      dataIndex: "employeeId",
      key: "employeeId",
    },
    {
      title: t("Incident Type"),
      dataIndex: "type",
      key: "type",
    },
    {
      title: t("Location"),
      dataIndex: "incidentlocation",
      key: "incidentlocation",
      render: (text) =>
        text
          ? text
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")
          : "",
    },
    {
      title: t("Reported on"),
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),
    },
    {
      title: t("Status"),
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        let displayStatus = text;

        if (text === "Commented") {
          if (record?.actiontimeline?.length > 0) {
            let foundPreviousStatus = false;
            for (let i = record.actiontimeline.length - 1; i >= 0; i--) {
              if (record.actiontimeline[i].actionmoveon !== "Commented") {
                displayStatus = record.actiontimeline[i].actionmoveon;
                foundPreviousStatus = true;
                break;
              }
            }
            if (!foundPreviousStatus) {
              displayStatus = "Waiting for Review";
            }
          } else {
            displayStatus = "Waiting for Review";
          }
        }

        if (displayStatus === "Waiting for Review") {
          return (
            <span className="clearance-text" style={{ cursor: "pointer" }}>
              {displayStatus}
            </span>
          );
        } else if (displayStatus === "Under Review") {
          return (
            <span className="suspend-text" style={{ cursor: "pointer" }}>
              {displayStatus}
            </span>
          );
        } else if (displayStatus === "Resolved") {
          return (
            <span className="res-text" style={{ cursor: "pointer" }}>
              {displayStatus}
            </span>
          );
        } else if (displayStatus === "Dismissed") {
          return (
            <span className="dis-text" style={{ cursor: "pointer" }}>
              {displayStatus}
            </span>
          );
        }
        return <span>{displayStatus}</span>;
      },
    },
    {
      key: "actions",
      width: 130,
      height: 50,
      render: (_, record) => {
        let displayStatus = record.status;

        if (record.status === "Commented") {
          if (record?.actiontimeline?.length > 0) {
            let foundPreviousStatus = false;
            for (let i = record.actiontimeline.length - 1; i >= 0; i--) {
              if (record.actiontimeline[i].actionmoveon !== "Commented") {
                displayStatus = record.actiontimeline[i].actionmoveon;
                foundPreviousStatus = true;
                break;
              }
            }
            if (!foundPreviousStatus) {
              displayStatus = "Waiting for Review";
            }
          } else {
            displayStatus = "Waiting for Review";
          }
        }

        return displayStatus === "Waiting for Review" ? (
          <div className="action-icons">
            {Menulist?.find(
              (item) => item?.key === "myincident" && item?.permission.edit
            ) && (
              <Edit
                onClick={(event) => {
                  event.stopPropagation();
                  const updatedRecord = {
                    ...record,
                    time: record?.time ? moment(record.time, "HH:mm:ss") : null,
                    updatedAt: record?.updatedAt
                      ? moment(record.updatedAt)
                      : null,
                  };
                  handleEditDisciplinary(updatedRecord);
                  form.setFieldsValue(updatedRecord);
                  setIsModalOpen(true);
                }}
              />
            )}
            {Menulist?.find(
              (item) => item?.key === "myincident" && item?.permission.delete
            ) && (
              <Trash
                onClick={(event) => {
                  event.stopPropagation();
                  handleDeleteClick(record?.incidentId);
                }}
              />
            )}
          </div>
        ) : null;
      },
    },
  ];

  const disableToDate = (current) => {
    return fromDate ? current && current.isBefore(fromDate, "day") : false;
  };

  const deleteIncident = async () => {
    if (!incidentToDelete) {
      message.error(t("Invalid incident ID."));
      return;
    }
    setLoading(true);
    try {
      const response = await CALL_API(
        `incident/${ClientId}/${incidentToDelete}`,
        "delete"
      );
      if (response.code === "SUCCESS") {
        setIsDeleteOpen(false);
        await getDisData();
        setIsDeletedModalOpen(true);
        setTimeout(() => setIsDeletedModalOpen(false), 1000);
        return true;
      } else {
        message.error(t("Failed to delete incident. Please try again."));
        return false;
      }
    } catch (error) {
      console.error("Delete API Error:", error);
      message.error(t("Something went wrong while deleting."));
      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let filtered = [...assetsData];

    if (searchText) {
      filtered = filtered.filter((incident) =>
        incident?.incidentlocation
          ?.toLowerCase()
          .includes(searchText.toLowerCase())
      );
    }
    if (selectedType) {
      filtered = filtered.filter(
        (incident) =>
          incident?.type?.trim().toLowerCase() === selectedType.toLowerCase()
      );
    }
    if (selectedStatus) {
      filtered = filtered.filter(
        (incident) =>
          incident?.status?.trim().toLowerCase() ===
          selectedStatus.toLowerCase()
      );
    }

    let startDate, endDate;
    if (selectedDateRange === "Last week") {
      startDate = moment().subtract(1, "weeks").startOf("week");
      endDate = moment().subtract(1, "weeks").endOf("week");
    } else if (selectedDateRange === "Last month") {
      startDate = moment().subtract(1, "months").startOf("month");
      endDate = moment().subtract(1, "months").endOf("month");
    } else if (selectedDateRange === "Last 6 months") {
      startDate = moment().subtract(6, "months").startOf("month");
      endDate = moment().endOf("month");
    } else if (selectedDateRange === "custom" && fromDate && toDate) {
      startDate = moment(fromDate).startOf("day");
      endDate = moment(toDate).endOf("day");
    }

    if (startDate && endDate) {
      filtered = filtered.filter((incident) =>
        moment(incident.date).isBetween(startDate, endDate, null, "[]")
      );
    }

    setFilteredData(filtered);
  }, [
    searchText,
    selectedType,
    selectedStatus,
    selectedDateRange,
    fromDate,
    toDate,
    assetsData,
  ]);

  const handleSelectChange = (value) => {
    setSelectedDateRange(value);
    if (value === "custom") {
      setShowDateRange(true);
    } else {
      setShowDateRange(false);
      setFromDate(null);
      setToDate(null);
    }
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };
  const incidentTypes = [
  { id: 1, label: "Asset Breakages", value: "Asset Breakages" },
  { id: 2, label: "Hardware Issues", value: "Hardware Issues" },
  { id: 3, label: "Software Issues", value: "Software Issues" },
  { id: 4, label: "System Problems", value: "System Problems" },
  { id: 5, label: "Application Problems", value: "Application Problems" },
  { id: 6, label: "Equipment Malfunctions", value: "Equipment Malfunctions" },
  { id: 7, label: "Other Technology-Related Incidents", value: "Other Technology-Related Incidents" },

  { id: 8, label: "Employee Relations", value: "Employee Relations" },
  { id: 9, label: "Attendance Matters", value: "Attendance Matters" },
  { id: 10, label: "Leave Matters", value: "Leave Matters" },
  { id: 11, label: "Workplace Conduct", value: "Workplace Conduct" },
  { id: 12, label: "Policy-Related Issues", value: "Policy-Related Issues" },
  { id: 13, label: "Grievances", value: "Grievances" },
  { id: 14, label: "Other Human Resource-Related Incidents", value: "Other Human Resource-Related Incidents" },

  { id: 15, label: "Workplace Accidents", value: "Workplace Accidents" },
  { id: 16, label: "Workplace Injuries", value: "Workplace Injuries" },
  { id: 17, label: "Unsafe Conditions", value: "Unsafe Conditions" },
  { id: 18, label: "Health Hazards", value: "Health Hazards" },
  { id: 19, label: "Safety Hazards", value: "Safety Hazards" },
  { id: 20, label: "Near-Miss Incidents", value: "Near-Miss Incidents" },
  { id: 21, label: "Other Occupational Safety Incidents", value: "Other Occupational Safety Incidents" },

  { id: 22, label: "Operational Issues", value: "Operational Issues" },
  { id: 23, label: "Work Performance Concerns", value: "Work Performance Concerns" },
  { id: 24, label: "Process Issues", value: "Process Issues" },
  { id: 25, label: "Workflow Issues", value: "Workflow Issues" },
  { id: 26, label: "Team-Related Matters", value: "Team-Related Matters" },
  { id: 27, label: "Supervisor Intervention Required", value: "Supervisor Intervention Required" },
  { id: 28, label: "Other Supervisory Incidents", value: "Other Supervisory Incidents" },
];

  return (
    <CustomStyle>
      <p style={{ fontWeight: 500, fontSize: 20 }}>{t("My Incident")}</p>
      <div className="totaldropdowns">
        <Row gutter={16}>
          <Col>
            <div>
              <Input
                className="search"
                placeholder={t("Search Location")}
                prefix={<SearchOutlined />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </Col>
          <Col>
            <div className="dropdown-container">
              {/* <Select
                placeholder={t("Incident Type")}
                className="action-dropdown"
                onChange={(value) => setSelectedType(value)}
                allowClear
              >
                <Select.Option value="Workplace Injury">
                  {t("Workplace Injury")}
                </Select.Option>
                <Select.Option value="Hazardous Material Exposure">
                  {t("Hazardous Material Exposure")}
                </Select.Option>
                <Select.Option value="Vehicle Accident">
                  {t("Vehicle Accident")}
                </Select.Option>
                <Select.Option value="Fire or Explosion">
                  {t("Fire or Explosion")}
                </Select.Option>
                <Select.Option value="Medical Emergency">
                  {t("Medical Emergency")}
                </Select.Option>
                <Select.Option value="Near Miss">
                  {t("Near Miss")}
                </Select.Option>
                <Select.Option value="Other">{t("Other")}</Select.Option>
              </Select> */}
              <Select
  placeholder={t("Incident Type")}
  className="action-dropdown"
  allowClear
  showSearch
  onChange={setSelectedType}
  options={incidentTypes.map((incident) => ({
    value: incident.value,
    label: t(incident.label),
  }))}
  optionFilterProp="label"
  filterOption={(input, option) =>
    option?.label?.toLowerCase().includes(input.toLowerCase())
  }
/>
            </div>
          </Col>
          <Col>
            <div className="dropdown-container">
              <Select
                placeholder={t("Date")}
                className="action-dropdown"
                onChange={handleSelectChange}
                allowClear
              >
                <Select.Option value="Last week">
                  {t("Last week")}
                </Select.Option>
                <Select.Option value="Last month">
                  {t("Last month")}
                </Select.Option>
                <Select.Option value="Last 6 months">
                  {t("Last 6 months")}
                </Select.Option>
                <Select.Option value="custom">
                  {t("Custom Date range")}
                </Select.Option>
              </Select>
            </div>
          </Col>
          {showDateRange && (
            <div className="date-range-container">
              <Col>
                <div>
                  <DatePicker
                    placeholder={t("From")}
                    format="DD-MM-YYYY"
                    className="datepicker-style"
                    onChange={(date) => {
                      setFromDate(date);
                      if (toDate && date && toDate.isBefore(date, "day")) {
                        setToDate(null);
                      }
                    }}
                  />
                </div>
              </Col>
              <Col>
                <div>
                  <DatePicker
                    placeholder={t("To")}
                    format="DD-MM-YYYY"
                    className="datepicker-style"
                    disabledDate={disableToDate}
                    onChange={(date) => setToDate(date)}
                  />
                </div>
              </Col>
            </div>
          )}
          <Col
            className={`dropdown-container ${
              showDateRange ? "adjust-margin" : ""
            }`}
          >
            <div className="dropdown-container">
              <Select
                placeholder={t("Status")}
                className="action-dropdown"
                onChange={handleStatusChange}
                allowClear
              >
                <Select.Option value="Waiting for Review">
                  {t("Waiting for Review")}
                </Select.Option>
                <Select.Option value="Under Review">
                  {t("Under Review")}
                </Select.Option>
                <Select.Option value="Resolved">{t("Resolved")}</Select.Option>
                <Select.Option value="Dismissed">
                  {t("Dismissed")}
                </Select.Option>
              </Select>
            </div>
          </Col>
        </Row>
      </div>
      <br />
      <p style={{ fontWeight: 400, fontSize: 16 }}>
        {t("Total Incident:")} {filteredData.length}
      </p>
      <Spin spinning={loading} size="medium">
        <Table
          dataSource={filteredData}
          columns={columns}
          pagination={true}
          rowClassName={() => "custom-row"}
          onRow={(record) => {
            return {
              onClick: (e) => {
                e.stopPropagation();
                history.push({
                  pathname: `/ViewIncident/${record.incidentId}`,
                  state: { incidentData: record, page: "myincident" },
                });
              },
            };
          }}
          scroll={{ x: "max-content" }}
          style={{ cursor: "pointer" }}
        />
      </Spin>
      <ReportIncident
        isModalVisible={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        details={selectedRecord}
        selectedIncidentId
      />
      <StyledModal
        width={470}
        footer={false}
        closable={false}
        open={isDeleteOpen}
        onCancel={handleDeleteCancel}
        style={{ marginTop: "100px" }}
      >
        <p className="delete-modal-text">
          {t("Are you sure you want to delete this incident?")}
        </p>
        <br />
        <div className="yes-no-button">
          <Button
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteCancel();
            }}
            className="no-button"
          >
            {t("No")}
          </Button>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              deleteIncident();
            }}
            className="yes-button"
            loading={loading}
          >
            {t("Yes")}
          </Button>
        </div>
      </StyledModal>
      <StyledModal
        width={190}
        height={70}
        open={isDeletedModalOpen}
        onCancel={() => setIsDeletedModalOpen(false)}
        footer={false}
        closable={false}
        style={{ marginTop: "130px" }}
      >
        <div className="success-modal">
          <Tick />
          <p className="sent-successfully">{t("Deleted")}</p>
        </div>
      </StyledModal>
    </CustomStyle>
  );
};

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  userList: getUserList(state),
  menuList: getMenuList(state),
});

export default connect(mapStateToProps)(MyIncident);
